export class TokenProvider {
    provider: string;
    providertoken: string;
    provideruserid: string;
    firstname: string;
    lastname: string;
    emailaddress: string;
    contactnumber: string;
    basketid: string;
    authtoken: string;
    newUser: string;

    public static Make(obj: any): TokenProvider {
        const tokenProvider = new TokenProvider();
        Object.assign(tokenProvider, obj);
        return tokenProvider;
    }
}
